<template>
  <div class="wptv-drilldown">
    <div
      class="title"
      @click="opened = true">
      <span class="title-slot">{{ label }}</span>
      <wptv-icon
        name="arrow-right"
        width="1em"
        height="1em" />
    </div>
    <transition name="drilldown">
      <div
        v-show="opened"
        class="panel">
        <div
          class="panel-title"
          @click="opened = false">
          <wptv-icon
            width="1em"
            height="1em"
            name="arrow-left"
            style="margin-right: 15px" />
          {{ label }}
        </div>
        <slot name="panel" />
      </div>
    </transition>
  </div>
</template>

<script>
import WptvIcon from '../../icon/Icon.vue'
export default {
  name: 'WptvDrilldown',
  components: {
    WptvIcon
  },
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      opened: false
    }
  },
  methods: {
    open () {
      this.opened = true
      this.$emit('opened')
    },
    close () {
      this.opened = false
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../../scss/abstracts/variables';

.wptv-drilldown {
  .panel {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    background: $white;
    min-height: 100%;
    width: 100%;
    overflow: hidden;
    will-change: transform;

    &.drilldown-enter-active,
    &.drilldown-leave-active {
      transition: max-width 0.13s cubic-bezier(0, 0, 0.3, 1);
    }

    &.drilldown-enter,
    &.drilldown-leave-to {
      max-width: 0;
    }

    &.drilldown-leave,
    &.drilldown-enter-to {
      max-width: 400px;
    }
  }

  .panel-title {
    display: flex;
    align-items: center;
    font-size: 1.6rem;
    border-bottom: 1px solid $lightgrey;
    padding: 10px;
    color: $black;
  }

  .title {
    display: flex;
    align-items: center;

    .title-slot {
      flex-grow: 1;
      padding: 10px 10px 10px 15px;
    }

    .wptv-icon {
      margin-right: 10px;
    }
  }
}
</style>
